module.exports = __webpack_public_path__ + "static/media/vzryvobezopasnye_pribory.f546894d.pdf";